import { use } from 'react';

import { UserContext, type UserContextValue } from './userContext';

export function useUser(): UserContextValue {
  const context = use(UserContext);
  if (!context) {
    throw new Error(
      'useUser must be used within a UserProvider. Make sure to wrap your component tree with <UserProvider>'
    );
  }
  return context;
}
